/*
 * 头部消息
 * author: v_xmdjliu
 * time: 2019-03-25
 */
import React, { PureComponent } from 'react';
import { observer } from 'mobx-react';
import { Select, Tabs, TabPanel, Loading, PageBar, Empty } from '@tencent/spaui';
import SPAUICollapseMini from './SPAUICollapseMini';
import './SelectionDataComponent.scoped.less';
import messageNotifyService from './services/notify';
import messageStore from './store/index';
import { formatAgencyList } from '@/pages/agency/utils/format';
import AccountSelect from '@/components/AccountSelect';
import { arrayToMap } from '@/utils';
import { AD_PLATFORM_TYPE_NAME } from '@/constants/Constants';

// 收件箱
@observer
export default class MsgNotify extends PureComponent {
  componentDidMount() {
    const {
      value: { agency_list },
    } = this.props;
    messageNotifyService.init(agency_list);
  }

  createTabPanel(tabLable, tabName) {
    const { list = [] } = messageStore.messageNotifyStore.notifyData;
    return (
      <TabPanel tab={tabLable} name={tabName} key={tabName}>
        <ul className="msgs">
          {list.length ? (
            list.map((x) => (
              <SPAUICollapseMini key={x.msg_id} msgId={x.msg_id} currentStatus={x.status} cssClassName={`msg-item${x.status != 2 ? ' unread' : ''}`} tagName="li">
                <div className="msg-info" href="javascript:;">
                  <span className="msg-via">{x.cate_name}</span>
                  <span className="msg-title">{x.title}</span>
                  <span className="msg-time">{x.date}</span>
                </div>
                <div className="msg-detail">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: messageNotifyService.handleShowContent(x.content),
                    }}
                  ></div>
                  <div onClick={() => messageNotifyService.deleteMsg(x.msg_id)} className="msg-item-action">
                    <a href="javascript:;">删除</a>
                  </div>
                </div>
              </SPAUICollapseMini>
            ))
          ) : (
            <Empty title="暂无消息" />
          )}
        </ul>
      </TabPanel>
    );
  }

  // 自定义 提示
  render() {
    const { tabsValue, config, agencyList = [], notifyData } = messageStore.messageNotifyStore;
    const { list = [], summary = [], loadingShow = true } = notifyData;
    const unreadMap = arrayToMap(summary, 'agency_uid');
    const select = config.agency_uid ? <AccountSelect className={'notice-account-select'} platform={AD_PLATFORM_TYPE_NAME.default} isGlobalUse={false} label={'服务商'} extra={unreadMap} defaultValue={config.agency_uid} onChange={messageNotifyService.agencyChange} placeholder="全部服务商" /> : null;

    return (
      <div className="notice-tabs">
        <div
          style={{
            zIndex: 1000,
            position: 'absolute',
            background: 'rgba(255,255,255,0)',
            width: '100%',
            height: '100%',
            display: loadingShow ? 'block' : 'none',
          }}
        >
          <Loading display="center" />
        </div>
        <Tabs onChange={(e, value) => messageNotifyService.handleTabsChange(value)} value={tabsValue} needSlider={false} endOfHeadContent={select}>
          {[this.createTabPanel('全部', 1), this.createTabPanel('未读', 2), this.createTabPanel('系统消息', 3), this.createTabPanel('审核消息', 4), this.createTabPanel('账户消息', 5), this.createTabPanel('财务消息', 6)]}
        </Tabs>
        <div className="inbox-card-footer">
          <PageBar type="mini" value={config.page} pageSize={10} totalSize={notifyData?.conf?.total_num || 0} onChange={(event, value) => messageNotifyService.handlePagesChange(value)} />
        </div>
      </div>
    );
  }
}
